import { DropdownOption } from 'components/form/Dropdown';
import { CoursePreview } from 'store/models/course/CoursePreview';

export const getCoursesOptions = (courses: CoursePreview[]): DropdownOption[] =>
  courses.map((c) => ({
    key: c.id,
    label: c.title,
  }));
